import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sucursal-limite-productos-pedido-abc-dialog',
  templateUrl: './sucursal-limite-productos-pedido-abc-dialog.component.html',
  styleUrls: ['./sucursal-limite-productos-pedido-abc-dialog.component.css']
})
export class SucursalLimiteProductosPedidoAbcDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
